import { useQuery } from "@tanstack/react-query";
import { apiClient } from "@lib/api";
import { API_ROUTES } from "../constants";
import type { VacancyData } from "../types/VacancyTypes";

export const QUERY_KEY = "getVacancies";

interface GetVacanciesParams {
  id?: string;
  per_page?: number;
  page?: number;
  search?: string;
  department?: string;
  location?: string;
  locale?: string;
  city?: string;
  company?: string;
  region?: string;
  countryCode?: string;
}

export const useGetVacancies = (params?: GetVacanciesParams) => {
  return useQuery({
    queryKey: [QUERY_KEY, params],
    queryFn: async (): Promise<VacancyData> => {
      const response = await apiClient.get<VacancyData>(API_ROUTES.vacancies, {
        headers: {
          "Content-Type": "application/json",
        },
        params,
      });
      return response.data;
    },
  });
};
